export default "__VITE_ASSET__DnpUPlkR__"